import React, { memo } from 'react';
import { Autocomplete, Box, Checkbox, Switch, TextField, FormControlLabel } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="medium" />;
const checkedIcon = <CheckBoxIcon fontSize="medium" />;

const BBSelect = (props) => {
  const isMultiple = props.multiple === true;

  let options = [];
  if (props.disableSort && props.options) {
    options = props.options;
  } else {
    options = props.options?.sort((a, b) => -b.label.localeCompare(a.label));
  }

  let currentValue = props.value;
  if (!isMultiple) {
    currentValue =
      options.find((option) => option.label === props.value || option._id === props.value) || null;
  }

  const CustomSwitch = React.forwardRef(({ children, ...other }, ref) => (
    <Box ref={ref} {...other}>
      <Box sx={{ pb: 1, px: 2, borderBottom: '1px solid #eee' }}>
        <FormControlLabel
          control={
            <Switch
              checked={props.isToggledOn}
              onChange={(e) => {
                props.onToggleChange(e.target.checked);
              }}
            />
          }
          label={props.toggleLabel}
        />
      </Box>

      <ul>{children}</ul>
    </Box>
  ));
  CustomSwitch.displayName = 'CustomSwitch';

  return (
    <Autocomplete
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      disableClearable={!isMultiple}
      multiple={isMultiple}
      id={props.id}
      options={options}
      value={currentValue}
      disableCloseOnSelect={isMultiple}
      onChange={(event, value) => {
        if (!isMultiple) {
          props.onChange(value);
        } else {
          props.onChange(value);
        }
      }}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      getOptionLabel={(option) => option.label}
      ListboxComponent={props.isToggleVisible && CustomSwitch}
      renderOption={(optionProps, option, { selected }) => {
        const { key, ...restOptionProps } = optionProps;
        return (
          <li key={key} {...restOptionProps}>
            {isMultiple && (
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                sx={{ pl: 0, mr: 0.5 }}
                checked={selected}
              />
            )}
            {option.label}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          error={props.error}
          helperText={props.helperText}
          placeholder={props.placeholder || ''}
        />
      )}
    />
  );
};

export default memo(BBSelect);
